<template>
    <div>
         <Form :model="formItem" ref="formItemSearch" :label-width="65">
            <Row>
                <Col span="24">
                    <Col span="4">
                        <FormItem label="职位名称" prop="name">
                            <Input v-model="formItem.name" placeholder="请输入" @keydown.native.enter.prevent="search"></Input>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <FormItem label="部门" prop="department_id">
                            <Select v-model="formItem.department_id" placeholder="请选择">
                                <Option v-for="item in departmentList" :key="item.id" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="16">
                        <Button type="primary" style="margin-left:5px" @click="search">查询</Button>
                        <Button type="primary" @click="reset('formItemSearch')">清空筛选</Button>
                        <Button type="primary" @click="add">添加</Button>
                    </Col>
                </Col>
            </Row>
        </Form>
        <div style="width:100%">
            <Table ref="table" stripe :loading="loading" border :columns="t_columns" :data="t_data" :height="tableHeight"></Table>
            <div style="margin-top:20px;display:flex;justify-content:flex-end">
                <Page :total="pagination.total" :page-size="pagination.per_page" show-total show-elevator show-sizer  @on-page-size-change="changeLimit"  @on-change="pageChange" :transfer="true" :page-size-opts="pageSizeOpts"/>
            </div>
        </div>
        <Modal
            v-model="ModalShow"
            :title="title"
            >
            <Form ref="formValidate" :model="editFormItem" :rules="ruleValidate" :label-width="80">
                <FormItem label="职位名称" prop="name">
                    <Input v-model="editFormItem.name" placeholder="请输入"></Input>
                </FormItem>
                <FormItem label="所属部门" prop="department_id">
                    <RadioGroup v-model="editFormItem.department_id">
                        <Radio v-for="item in departmentList" :key="item.id" :label="item.id+''">
                            <span>{{item.name}}</span>
                        </Radio>
                    </RadioGroup>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="close">取消</Button>
                <Button type="primary" size="large" @click="handleSubmit ('formValidate')">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:'position',
    data(){
        return{
            tableHeight: 500,
            pageSizeOpts:[50,60,70,80,90,100],
            loading:false,
            ModalShow:false,
            title:"",
            formItem:{
                name:"",
                department_id:"",
                page:1,
                limit:50
            },
            editFormItem:{
                name:'',
                department_id:""
            },
            ruleValidate:{
                name: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                department_id: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
            },
            t_columns: [
                {
                    width: 60,
                    align: 'center',
                    title:"序号",
                    render: (h,params) => {
                        return h('span',
                        (params.index + 1) + (this.pagination.per_page * (this.pagination.current_page-1)))
                    }
                },
                {
                    title: '职位名称',
                    key: 'name',
                    align: 'center',
                },
                {
                    title: '所属部门',
                    key: 'department_name',
                    align: 'center',
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.edit(params.row.id)
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.remove(params.row.id)
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }
            ],
            t_data: [],
            pagination:{},
            departmentList:[],
            listDetailId:0
        }
    },
    created(){
        this.apiDepartmentAll()
        this.apiPositionList()
    },
    mounted(){
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 205
    },
    methods:{
        changeLimit(val){
            this.formItem.limit=val
            this.apiPositionList()
        },
        add(){
            this.$refs.formValidate.resetFields()
            this.title = "添加职位"
            this.ModalShow = true
        },
        edit(id){
            this.$refs.formValidate.resetFields()
            this.title = "编辑职位"
            this.listDetailId = id
            this.apiPositionDetail(id)
            this.ModalShow = true
        },
        remove(id){
            this.apiPositionRemove(id)
        },
        apiDepartmentAll(){
            serve.fetchGet(api.positionDepartment,{}).then(data => {
                console.log(data)
                this.departmentList = data.data     
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiPositionList(){
            this.loading = true
            serve.fetchGet(api.position,this.formItem).then(data => {
                console.log(data)
                this.t_data = data.data
                this.pagination = data.meta.pagination
                this.loading = false
            }).catch((error)=>{
                this.loading = false
                this.$Message.error(error.response.data.message);
            })
        },
        apiPositionAdd(){
            serve.fetchPost(api.position,this.editFormItem).then(data => {
                console.log(data)
                this.$Message.success('添加成功');
                this.ModalShow = false
                this.apiPositionList() 
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiPositionDetail(id){
            serve.fetchGet(api.position+'/'+id,{}).then(data => {
                console.log(data)
                this.editFormItem.name = data.data.name
                this.editFormItem.department_id = data.data.department_id+""
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiPositionEdit(){
            serve.fetchPut(api.position+'/'+this.listDetailId,this.editFormItem).then(data => {
                console.log(data)
                this.$Message.success('编辑成功');
                this.ModalShow = false
                this.apiPositionList() 
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiPositionRemove(id){
            serve.fetchDelete(api.position+"/"+id,{}).then(data => {
                console.log(data)
                this.$Message.success('删除成功');
                this.apiPositionList() 
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        close(){
            this.ModalShow = false
        },
        handleSubmit(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if(this.title === "添加职位"){
                        this.apiPositionAdd()
                        return
                    }
                    this.apiPositionEdit()
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        },
        pageChange(page){
            this.formItem.page = page
            this.apiPositionList()
        },
        search(){
            this.formItem.page = 1
            this.apiPositionList()
        },
        reset(name){
            this.formItem.page = 1
            this.$refs[name].resetFields()
            this.apiPositionList()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/SystemSetting/System/position.vue